/* eslint-disable no-dupe-keys */
export default {
  charging_card_definition: {
    name: '充电卡模板',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '卡名',
      amount: '初始金额',
      count: '充电卡数量',
      service_provider: '运营商',
      charge_stations: '适用电站',
      ev_charging_station_id: '适用电站',
      effective_date: '生效日期',
      effective_date_type: '生效日期类型',
      discount_orders_count: '优惠订单数',
      remaining_amount: '剩余金额',
      effective_days: '生效天数',
      effective_time: '生效日期',
      effective_begin_time: '生效开始日期',
      effective_end_time: '生效结束日期',
      discount_orders_amount: '优惠金额',
      discount_stacking_type: '优惠叠加',
      status: '状态',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    effective_date_types: {
      fixed: '指定日期',
      after_given: '从获取后开始'
    },
    discount_stacking_types: {
      exclusive: '优惠互斥',
      unrestricted: '优惠叠加'
    },
    statuses: {
      enabled: '已启用',
      disabled: '已停用',
      pending: '待生效',
      available: '生效中',
      expired: '已过期'
    },
    virtual_statuses: {
      pending: '待生效',
      available: '生效中',
      expired: '已过期'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询充电卡名称'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      charging_cards: '充电卡',
      consumption_records: '消费记录'
    },
    // 标题
    titles: {
      base_info: '基本信息',
      effective_time: '生效时间',
      using_rules: '使用规则',
      activity_info: '活动规则'
    },
    // 标签
    labels: {
      cards_count: '卡数量',
      discount_orders_count: '优惠订单数',
      discount_orders_amount: '优惠金额'
    },
    // tab
    list_tabs: {
      enabled: '已启用',
      all: '全部'
    },
    tips: {
      charging_card_settlement: '充电卡钱包类似用户个人余额，消费的钱会在订单结算后转入运营商账户',
      channel: '充电卡可以通过礼品卡、用户发送优惠的渠道发放',
      unrestricted_discount: '叠加表示可以 与 其它（也支持叠加的）不同类型优惠同时使用'
    }
  }
}
